module.exports = __webpack_public_path__ + "img/Waiting Passengers.a7a274be.svg";